
import axios from "axios";
import { URL_BASE } from "../config/url-server";
const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")






export const getHealthIssue = async (userId) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.get(URL_BASE + "health-issue/get/" + userId, config)
    const user = response.data?.data || null;
    return user;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const getList = async (page,limit,findName) => {
  const params = {page,limit,findName};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "health-issue/list",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const insert = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "health-issue/insert", data, config)
    const success = response?.data || null;
    return success;
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};


export const update = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "health-issue/update", data, config)
    const success = response.data?.success || null;
    return success;
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};



export const list = async (page, limit, findName) => {
  try {
    const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
    const url = `${URL_BASE}health-issue/list?page=${page}&limit=${limit}&name=${findName}`
    const response = await axios.get(url, config)
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const getListPagination = async (page,limit,findName) => {
  const params = {page,limit,findName};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "health-issue/list-pagination",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export default {
  getListPagination,
  getList,
  list,
  getHealthIssue,
  getList,
  insert,
  update
}

